import React, { Suspense, lazy, Fragment, Component } from "react";
import isArray from "lodash/isArray";

import Label from "./Label";
import { Loading } from "Components/Partials/Layouts";

const InputField = lazy(() => import("./InputField"));

const fieldMap = {
    text: {
        component: InputField,
        props: {
            type: "text",
        },
        getValue: (e) => e.target?.value,
    },
    email: {
        component: InputField,
        props: {
            type: "email",
        },
        getValue: (e) => e.target?.value,
    },
    number: {
        component: InputField,
        props: {
            type: "number",
        },
        getValue: (e) => e.target?.value,
    },
    select: {
        component: lazy(() => import("./Select")),
        getValue: (e) => e,
    },
    date: {
        component: lazy(() => import("./DateTimeField")),
        getValue: (e) => e,
    },
    toggle: {
        component: lazy(() => import("./Toggle")),
        getValue: (e) => e,
    }
}

class Renderer extends Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const { fields } = this.props;

        return (
            <>
                {this.renderFields(fields)}
            </>
        );
    }

    /**
     * @method renderFields
     * @param {array} fields
     * @returns {JSX.Element}
     */
    renderFields = (fields) => {
         return (
            <>
                {fields.map((field, index) => (
                    <Fragment key={`container-${index}`}>
                        {(() => {
                            if (isArray(field)) {
                                return (
                                    <div
                                        className="flex gap-x-4"
                                        key={`row-${index}`}
                                    >
                                        {this.renderFields(field)}
                                    </div>
                                );
                            }

                            const Component = fieldMap[field.type].component;

                            return (
                                <div
                                    key={`${field.name}-${index}`}
                                    className="flex-1"
                                >
                                    <Suspense fallback={<Loading />}>
                                        {field.label && (
                                            <Label>{field.label}</Label>
                                        )}

                                        <Component
                                            {...fieldMap[field.type].props}
                                            {...field}
                                            value={this.props.form[field.name]}
                                            onChange={(e) => this.props.onChange(field.name, fieldMap[field.type].getValue(e))}
                                        />
                                    </Suspense>
                                </div>
                            );
                        })()}
                    </Fragment>
                ))}
            </>
        );
    };
}

export default Renderer;
